import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '../../../customer/applicationManage/request';
import { isPDF, isImage, isVideo, getBase64 } from '@/views/claim/demageManage/utils';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import eventBus from '@/utils/eventBus';
import { claimsApplyAuditStore } from '../request';
import previewListModal from '@/views/claim/demageManage/previewListModal.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { cryptoDecrypt } from '@/utils/aes';
import { plainOptions } from '@/views/claim/demageManage/utils';
export default {
  components: {
    previewModal,
    previewListModal
  },
  data() {
    return {
      plainOptions,
      action: uploadFile,
      fileDialog: false,
      uploadAccept: '',
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      currentPreviewIndex: 0,
      previewVisible: false,
      isShow: '',
      previewFileList: [],
      submitInfo: {},
      previewListVisible: false,
      modalPreviewList: [],
      loading: false,
      additionalFileList: []
    };
  },
  mounted() {
    eventBus.$on('policyClaimInfo', info => {
      this.submitInfo = info;
    });
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      if (!this.submitInfo.claimsDocument) {
        this.loading = false;
        return;
      }
      // const res = this.submitInfo.claimsDocument.find(item => item.documentUrl.length === 0);
      // if (res) {
      //   this.loading = false;
      //   this.$message.error('请先上传文件');
      //   return;
      // }
      let returnRes = true;
      let submitParams = recursionCopy(this.submitInfo);
      let submitAdditionalParams = recursionCopy(this.additionalFileList);
      submitParams.claimsSort.map(item => {
        item.claimsParam.map(item2 => {
          delete item2.selectarr;
        });
      });
      // if (submitAdditionalParams.length) {
      let itemObj = {
        documentId: 0,
        documentName: this.$t('补充文件'),
        documentFormat: this.plainOptions,
        documentDescription: '',
        documentTemplateUrl: [],
        documentUrl: submitAdditionalParams,
        auditOpinion: ''
      };
      submitParams.claimsDocument.push(itemObj);
      // }
      submitParams.claimsDocument.map(item => {
        let uploadUrl = [];
        let templateUrl = [];
        item.documentTemplateUrl.map(item2 => {
          templateUrl.push(item2.url);
        });
        item.documentUrl.map(file => {
          if (file.status === 'done') {
            uploadUrl.push(file.url);
          } else {
            this.$message.warn(this.$t('文件上传中或文件上传错误'));
            returnRes = false;
            return;
          }
        });
        item.documentUrl = uploadUrl;
        item.documentTemplateUrl = templateUrl;
      });
      if (!returnRes) {
        this.loading = false;
        return;
      }
      let obj = {
        policyId: this.$route.params.id,
        claimsTypeId: submitParams.claimsTypeId,
        claimsContent: JSON.stringify(submitParams)
      };
      // console.log(submitParams);
      const res = await claimsApplyAuditStore(obj, this.$route.params.type);
      console.log(res);
      if (res.code != 200) {
        this.loading = false;
        return this.$message.error(this.$t(res.message));
      }
      this.$message.success(this.$t('保存成功'));
      this.loading = false;
      this.$router.go(-1);
      // this.$router.push('/claim/customerReportManage');
    },
    clickPlus(index) {
      this.$nextTick(() => {
        if (index !== 'addition') {
          this.toChangeUploadAccept(this.submitInfo.claimsDocument[index].documentFormat);
        } else {
          this.toChangeUploadAccept(this.plainOptions);
        }
        this.fileDialog = true;
      });
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    removeUploadFile(file, i) {
      if (i || i === 0) {
        const index = this.submitInfo.claimsDocument[i].documentUrl.indexOf(file);
        const newFileList = this.submitInfo.claimsDocument[i].documentUrl.slice();
        newFileList.splice(index, 1);
        this.submitInfo.claimsDocument[i].documentUrl = newFileList;
      } else {
        const index = this.additionalFileList.indexOf(file);
        const newFileList = this.additionalFileList.slice();
        newFileList.splice(index, 1);
        this.additionalFileList = newFileList;
      }
    },
    // 点击模板预览
    onModalPreview(index) {
      this.modalPreviewList = this.submitInfo.claimsDocument[index].documentTemplateUrl.map((item, i) => {
        let obj = {};
        obj.status = 'done';
        obj.uid = i + 1;
        obj.url = item.url;
        obj.format = item.format;
        obj.name = item.name;
        return obj;
      });
      this.previewListVisible = true;
    },
    // 预览处理
    async handlePreview(file, index) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      console.log(file);
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.response.data.fileTempUrl || file.preview;
        if (index || index === 0) {
          this.currentPreviewIndex = this.submitInfo.claimsDocument[index].documentUrl.indexOf(file);
          this.previewFileList = this.submitInfo.claimsDocument[index].documentUrl;
        } else {
          this.currentPreviewIndex = this.additionalFileList.indexOf(file);
          this.previewFileList = this.additionalFileList;
        }
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        this.$message.warn(file.name.split('.')[1] + this.$t('文件暂不支持预览'));
        return;
      }
      this.previewVisible = true;
    },
    changeUpload({
      file,
      fileList
    }, index) {
      console.log(file, fileList);
      const isThanMax = file.size / 1024 / 1024 < 30;
      if (!isThanMax) {
        this.$message.error(this.$t('文件最大不超30M'));
      } else {
        const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1).toLowerCase();
        console.log(fileType);
        const res = index || index === 0 ? this.submitInfo.claimsDocument[index].documentFormat.indexOf(fileType) : this.plainOptions.indexOf(fileType);
        let new_fileList = fileList.map(item => {
          if (item.response && item.response.code == 200 && item.status == 'done') {
            if (process.env.NODE_ENV === 'production') {
              item.url = cryptoDecrypt(item.response.data) ? cryptoDecrypt(item.response.data).fileTempUrl : null;
            } else {
              item.url = item.response.data ? item.response.data.fileTempUrl : null;
            }
          }
          return item;
        });
        if (file.status == 'done') {
          const index2 = new_fileList.findIndex(item => !item.url);
          console.log(index2);
          if (index2 > -1) {
            this.$message.error(this.$t('文件上传失败,请重新上传'));
            new_fileList.splice(index2, 1);
          }
        }
        if (res > -1) {
          if (index || index === 0) {
            this.submitInfo.claimsDocument[index].documentUrl = new_fileList;
          } else {
            this.additionalFileList = new_fileList;
          }
        } else {
          this.$message.error(this.$t('文件格式错误'));
        }
      }
      setTimeout(() => {
        const classActions = document.getElementsByClassName('ant-upload-list-item-actions');
        if (classActions.length > 0) {
          for (const key in classActions) {
            if (classActions[key].firstChild) {
              classActions[key].firstChild.style.opacity = '1';
              classActions[key].firstChild.style.pointerEvents = 'initial';
            }
          }
        }
      }, 50);
    }
  }
};